import { useState } from "react";

import { Address } from "types/address";

export function useAddress(
  props: Partial<Address>
): [Address, (props: Partial<Address>) => void] {
  const [address, setAddress] = useState<string>(props.address || "");
  const [state, setstate] = useState<string>(props.state || "");
  const [city, setCity] = useState<string>(props.city || "");
  const [postcode, setPostcode] = useState<string>(props.postcode || "");
  const [country, setCountry] = useState<string>(props.country || "");
  const [address2, setAddress2] = useState<string>(props.address2 || "");

  const set = (values: Partial<Address>) => {
    if (values.address !== undefined) {
      setAddress(values.address);
    }
    if (values.state !== undefined) {
      setstate(values.state);
    }
    if (values.city !== undefined) {
      setCity(values.city);
    }
    if (values.postcode !== undefined) {
      setPostcode(values.postcode);
    }
    if (values.country !== undefined) {
      setCountry(values.country);
    }
    if (values.address2 !== undefined) {
      setAddress2(values.address2);
    }
  };

  return [{ address2, address, city, postcode, state, country }, set];
}
